import React, { useState } from "react";
import { ChevronLeft, Clock3, Plus } from "lucide-react";
import InstructorLayout from "../../layouts/InstructorLayout";
import {
  useCreateInstructorSlotMutation,
  useDeleteInstructorSlotMutation,
  useGetInstructorMySlotsQuery,
  useUpdateInstructorSlotMutation,
} from "../../services/instructor/instructor";
import { useNavigate } from "react-router-dom";
import { Calender, Clock } from "../../components/Icons";
import {
  CalenderAvailibility,
  DeleteSession,
  EditSession,
  WeeklyRecurring,
} from "../../components/instructor/icons";
import AddTimeSlotModal from "../../components/instructor/AddTimeSlotModal";
import UpdateTimeSlotModal from "../../components/instructor/UpdateTimeSlotModal";
import Toast from "../../components/common/Toast";

const Card = ({ icon, value, title, bg }) => (
  <div
    className={`${bg} font-['Inter'] shadow-[3px_1px_4px_0_#00000040]  px-3 lg:px-4 py-4 lg:py-5  flex items-center gap-3 lg:gap-4 rounded-[6px] `}
  >
    <div>{icon}</div>

    <div className="text-black">
      <h3 className="text-[22px] lg:text-[26px]  font-semibold leading-7 lg:leading-[31px] ">{value}</h3>

      <p className=" lg:mt-1.5 text-lg lg:text-[22px]    leading-[27px]">{title}</p>
    </div>
  </div>
);
const SetAvailability = () => {
  const allDays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const formatTime = (time) => {
    const [hour, minute] = time.split(":");
    const date = new Date();
    date.setHours(hour, minute);

    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  const { data: slotsResponse, refetch: refetchSlots } =
    useGetInstructorMySlotsQuery();
  const [
    createInstructorSlot,
    { isLoading: isCreatingSlot, error: createSlotError },
  ] = useCreateInstructorSlotMutation();
  const [deleteInstructorSlot, { isLoading: isDeletingSlot }] =
    useDeleteInstructorSlotMutation();
  const [
    updateInstructorSlot,
    { isLoading: isUpdatingSlot, error: updateSlotError },
  ] = useUpdateInstructorSlotMutation();
  const createSlotErrorMessage = createSlotError?.data?.message
    ? createSlotError.data.message
    : createSlotError
      ? "Failed to create time slot."
      : "";
  const updateSlotErrorMessage = updateSlotError?.data?.message
    ? updateSlotError.data.message
    : updateSlotError
      ? "Failed to update time slot."
      : "";
  const [slotToDelete, setSlotToDelete] = useState(null);
  const [showAddSlotModal, setShowAddSlotModal] = useState(false);
  const [showUpdateSlotModal, setShowUpdateSlotModal] = useState(false);
  const [slotToEdit, setSlotToEdit] = useState(null);
  const initialAddSlotForm = {
    sessionTitle: "",
    scheduleType: "Recurring Weekly",
    days: [],
    startTime: "",
    endTime: "",
  };
  const [addSlotForm, setAddSlotForm] = useState(initialAddSlotForm);
  const [editSlotForm, setEditSlotForm] = useState(initialAddSlotForm);
  const [toast, setToast] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });
  const slots = slotsResponse?.data || [];
  const activeSlots = slots.filter((item) => item.isActive);
  const availability = allDays.map((day) => {
    let time = "No Availability";

    activeSlots.forEach((slot) => {
      if (slot.days.includes(day)) {
        time = `${formatTime(slot.startTime)} - ${formatTime(slot.endTime)}`;
      }
    });

    return {
      day,
      time,
    };
  });


  const isUpdateDirty = slotToEdit
    ? JSON.stringify({
        sessionTitle: slotToEdit.sessionTitle || "",
        scheduleType: slotToEdit.scheduleType || "Recurring Weekly",
        days: slotToEdit.days || [],
        startTime: slotToEdit.startTime || "",
        endTime: slotToEdit.endTime || "",
      }) !== JSON.stringify(editSlotForm)
    : true;

  const totalTimeSlots = slotsResponse?.summary?.totalTimeSlots || 0;
  const totalWeeks = slotsResponse?.summary?.totalWeeks || 0;
  const totalDays = slots.reduce((total, slot) => total + slot.days.length, 0);
  const totalHours = slots.reduce((total, slot) => {
    const start = Number(slot.startTime.split(":")[0]);
    const end = Number(slot.endTime.split(":")[0]);

    return total + (end - start) * slot.days.length;
  }, 0);

  const stats = [
    {
      title: "Total Time Slots",
      value: totalTimeSlots,
      icon: <CalenderAvailibility />,
      bg: "bg-[#089BC424]",
    },
    {
      title: "Total Hours",
      value: totalHours,
      icon: <Clock color="#14AE5C" width="49" height="49" />,
      bg: "bg-[#089BC424]",
    },
    {
      title: "Total Days",
      value: totalDays,
      icon: <Clock color="#14AE5C" width="49" height="49" />,
      bg: "bg-[#089BC424]",
    },
    {
      title: "Total Weeks",
      value: totalWeeks,
      icon: <Clock color="#14AE5C" width="49" height="49" />,
      bg: "bg-[#089BC424]",
    },
  ];

  const navigate = useNavigate();
  return (
    <InstructorLayout>
      <div className="pt-6 px-6 lg:px-8 2xl:pr-[60px] 2xl:pl-9 font-['Inter']">
        <div className="flex ml-1 items-center gap-4 text-sm mb-3 font-['Roboto']">
          <span className="text-[#6E7485]">Dashboard</span>

          <span className="text-[#6E7485]">/</span>

          <span className="text-[#1D2026] ">Notifications</span>
        </div>

        <button onClick={() => navigate(-1)} className="mb-5">
          <ChevronLeft size={30} className="text-[#089BC4]" />
        </button>

        <div className="bg-white shadow-[-1px_-1px_4.3px_0_#00000040] px-5 lg:px-8 2xl:pl-10 2xl:pr-20 py-5 2xl:py-7">
          <div className=" flex items-start justify-between gap-6 flex-wrap">
            <div>
              <h1 className="text-2xl lg:text-[28px] font-semibold text-[#000] leading-8 lg:leading-[38px]">
                Set Availability
              </h1>
              <p className="mt-1 lg:mt-3  leading-5 text-[#6E6E6E]">
                Manage your availability for live sessions
              </p>
            </div>

            <button
              type="button"
              className="inline-flex items-center lg:text-lg gap-1 rounded bg-[#089BC4] px-5 lg:px-7 py-1.5 text-white font-medium"
              onClick={() => setShowAddSlotModal(true)}
            >
              <Plus size={20} />
              Add Time Slot
            </button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 lg:gap-6 mt-6 lg:mt-8">
            {stats.map((item) => (
              <Card
                key={item.title}
                icon={item.icon}
                value={item.value}
                title={item.title}
                bg={item.bg}
              />
            ))}
          </div>
          <div className="mt-7 min-h-[420px] rounded-[15px] bg-[#FAFAFABF] shadow-[2px_2px_4.4px_0_#00000026]">
            {activeSlots.length === 0 ? (
              <div className="h-[420px] p-5 max-[500px]:p-4 min-[500px]:p-9">
                <p className="flex items-center gap-2 font-semibold leading-6 text-[#089BC4] max-[500px]:text-xl min-[500px]:gap-3 min-[500px]:text-[26px] lg:gap-4 lg:text-[30px]">
                  <span className="shrink-0 max-[500px]:scale-75">
                    <Calender color="#089BC4" width="36" height="36" />
                  </span>
                  <span>Your Availability</span>
                </p>
                <div className="flex h-full flex-col items-center justify-center text-center">
                  <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border-4 border-[#E5E7EB] min-[500px]:h-20 min-[500px]:w-20">
                    <Clock color="#0000006B" width="81" height="81" />
                  </div>
                  <h3 className="mt-3 font-semibold text-black max-[500px]:text-xl min-[500px]:text-[28px]">
                    No availability set
                  </h3>
                  <p className="mt-3 leading-snug text-[#6E6E6E] max-[500px]:px-1 max-[500px]:text-base max-[500px]:leading-5 min-[500px]:text-2xl min-[500px]:leading-5">
                    Add your first time slot to get started with scheduling
                    sessions.
                  </p>
                </div>
              </div>
            ) : (
              <div className="w-full space-y-4 p-3 lg:p-6">
                <p className="flex items-center gap-2 font-semibold leading-6 text-[#089BC4] max-[500px]:text-xl min-[500px]:gap-3 min-[500px]:text-[26px] lg:gap-4 lg:text-[30px]">
                  <span className="shrink-0 max-[500px]:scale-75">
                    <Calender color="#089BC4" width="36" height="36" />
                  </span>
                  <span>Your Availability</span>
                </p>
                <div className="rounded-2xl bg-[#FAFAFABF] p-3 shadow-[inset_2px_4px_4.4px_0_#00000026] max-[500px]:p-3 min-[500px]:p-4 lg:p-6 xl:px-8 xl:py-9">
                  <p className="flex items-center gap-2">
                    <WeeklyRecurring />
                    <span className="font-semibold text-[#2B2B2B] max-[500px]:text-lg min-[500px]:text-xl lg:text-2xl">
                      Weekly Recurring
                    </span>
                  </p>
                  <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:mt-8 xl:grid-cols-4 2xl:gap-x-10 2xl:gap-y-6">
                    {availability.map((itm, idx) => {
                      const isAvailable =
                        itm.time === "No Availability" ? false : true;
                      return (
                        <div
                          key={idx * 32}
                          className={`${isAvailable ? "bg-[#22C55E1F] text-[#14AE5C]" : "bg-[#DC26261F] text-[#EB4C4C]"} rounded-2xl p-3 shadow-[3px_1px_4px_0_#00000040] max-[500px]:p-3 min-[500px]:p-4 lg:rounded-[19px]`}
                        >
                          <h2 className="font-semibold leading-7 max-[500px]:text-lg min-[500px]:text-[22px] lg:text-[26px] lg:leading-[31px]">
                            {itm.day}
                          </h2>
                          <p className="mt-0.5 leading-6 max-[500px]:text-sm min-[500px]:text-lg lg:mt-1.5 lg:text-[22px] lg:leading-[27px]">
                            {itm.time}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                  {activeSlots.length > 0 && (
                    <div className="mt-8 space-y-2">
                      {activeSlots.map((session) => {
                        const sessionTime = `${formatTime(
                          session.startTime,
                        )} - ${formatTime(session.endTime)}`;
                        return (
                          <div
                            key={session._id}
                            className="rounded-[10px] border border-[#D9D9D9] bg-[#F2F2F2] px-3 pb-5 pt-4 max-[500px]:px-3 min-[500px]:px-4 min-[500px]:pb-7 min-[500px]:pt-[22px] lg:px-6 lg:pb-8 xl:px-8"
                          >
                            <div className="flex items-center justify-between gap-3 max-[500px]:gap-2 sm:gap-6">
                              <p className="flex min-w-0 items-center gap-2 max-[500px]:gap-1.5 min-[500px]:gap-2.5">
                                <Clock3 />
                                <span className="leading-7 text-black max-[500px]:text-base min-[500px]:text-[22px] lg:text-[26px] lg:leading-[31px]">
                                  {sessionTime}
                                </span>
                              </p>
                              <div className="flex shrink-0 items-center gap-3 xl:gap-6">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSlotToEdit(session);
                                    setEditSlotForm({
                                      sessionTitle: session.sessionTitle || "",
                                      scheduleType:
                                        session.scheduleType ||
                                        "Recurring Weekly",
                                      days: session.days || [],
                                      startTime: session.startTime || "",
                                      endTime: session.endTime || "",
                                    });
                                    setShowUpdateSlotModal(true);
                                  }}
                                >
                                  <EditSession />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setSlotToDelete(session)}
                                >
                                  <DeleteSession />
                                </button>
                              </div>
                            </div>
                            <div className="ml-1 mt-4 flex flex-wrap gap-2 max-[500px]:gap-2 min-[500px]:gap-4 lg:mt-6 xl:gap-[22px]">
                              {session.days.map((day) => (
                                <p
                                  key={`${session._id}-${day}`}
                                  className="rounded-full border border-[#BABABA38] bg-[#14AE5C1A] px-[14px] py-[3px] text-[#14AE5C] max-[500px]:px-3 max-[500px]:text-sm min-[500px]:text-xl lg:text-2xl"
                                >
                                  {day}
                                </p>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {slotToDelete ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-sm rounded-xl bg-white p-5 shadow-[0_8px_30px_0_#00000033]">
            <h3 className="text-lg font-semibold text-[#1D2026]">
              Delete time slot?
            </h3>
            <p className="mt-2 text-sm text-[#6E7485]">
              This will remove the slot from your availability.
            </p>
            <div className="mt-5 flex items-center justify-end gap-3">
              <button
                type="button"
                className="rounded-lg border border-[#E5E7EB] px-4 py-2 text-sm font-medium text-[#1D2026]"
                onClick={() => setSlotToDelete(null)}
                disabled={isDeletingSlot}
              >
                Cancel
              </button>
              <button
                type="button"
                className="rounded-lg bg-[#DC2626] px-4 py-2 text-sm font-medium text-white"
                onClick={async () => {
                  if (!slotToDelete?._id || isDeletingSlot) {
                    return;
                  }
                  try {
                    const response = await deleteInstructorSlot(
                      slotToDelete._id,
                    ).unwrap();
                    setSlotToDelete(null);
                    refetchSlots();
                    setToast({
                      show: true,
                      variant: "success",
                      title: "Success",
                      message:
                        response?.message || "Time slot deleted successfully.",
                    });
                  } catch (error) {
                    // Keep modal open on failure.
                  }
                }}
                disabled={isDeletingSlot}
              >
                {isDeletingSlot ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <AddTimeSlotModal
        open={showAddSlotModal}
        allDays={allDays}
        form={addSlotForm}
        setForm={setAddSlotForm}
        errorMessage={createSlotErrorMessage}
        isSubmitting={isCreatingSlot}
        onClose={() => setShowAddSlotModal(false)}
        onSubmit={async () => {
          if (isCreatingSlot) {
            return;
          }
          try {
            const response = await createInstructorSlot(addSlotForm).unwrap();
            setAddSlotForm(initialAddSlotForm);
            setShowAddSlotModal(false);
            refetchSlots();
            setToast({
              show: true,
              variant: "success",
              title: "Success",
              message: response?.message || "Time slot created successfully.",
            });
          } catch (error) {
            // Keep modal open on failure.
          }
        }}
      />
      <UpdateTimeSlotModal
        open={showUpdateSlotModal}
        allDays={allDays}
        form={editSlotForm}
        setForm={setEditSlotForm}
        errorMessage={updateSlotErrorMessage}
        isSubmitting={isUpdatingSlot}
        isSubmitDisabled={!isUpdateDirty}
        onClose={() => {
          setShowUpdateSlotModal(false);
          setSlotToEdit(null);
          setEditSlotForm(initialAddSlotForm);
        }}
        onSubmit={async () => {
          if (!slotToEdit?._id || isUpdatingSlot) {
            return;
          }
          try {
            const response = await updateInstructorSlot({
              slotId: slotToEdit._id,
              body: editSlotForm,
            }).unwrap();
            setShowUpdateSlotModal(false);
            setSlotToEdit(null);
            setEditSlotForm(initialAddSlotForm);
            refetchSlots();
            setToast({
              show: true,
              variant: "success",
              title: "Success",
              message:
                response?.message || "Time slot updated successfully.",
            });
          } catch (error) {
            // Keep modal open on failure.
          }
        }}
      />

      {toast.show ? (
        <Toast
          variant={toast.variant}
          title={toast.title}
          message={toast.message}
          onClose={() => setToast((current) => ({ ...current, show: false }))}
        />
      ) : null}
    </InstructorLayout>
  );
};

export default SetAvailability;
